// extracted by mini-css-extract-plugin
export default {"reviewsArticleListingHorizontalCard":"HorizontalArticleCards_reviewsArticleListingHorizontalCard__AK7P-"};